<template>
  <div class="page-efficiency">
    <!-- Begin head block -->
    <section class="head-block">
      <div class="container">
        <h1 class="head-block__title" v-html="$t('efficiency.title')"></h1>
        <div class="row">
          <div class="col-x-lg-6 col-lg-6 col-md-6 col-xs-12">
            <div class="head-block__detail">
              <p
                class="head-block__detail-text"
                v-html="$t('efficiency.text_1')"
              ></p>
            </div>
          </div>
          <div class="col-x-lg-6 col-lg-6 col-md-6 col-xs-12">
            <div class="head-block__detail">
              <p
                class="head-block__detail-text"
                v-html="$t('efficiency.text_2')"
              ></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-x-lg-6 col-lg-6 col-md-6 col-xs-12">
            <div class="head-block__graphic">
              <div
                class="head-block__graphic-title"
                v-html="$t('efficiency.graphic_1.title')"
              ></div>
              <div class="head-block__graphic-image">
                <img src="~@/assets/img/efficiency/graphic-1.png" alt="" />
              </div>
              <div
                class="head-block__graphic-subtitle"
                v-html="$t('efficiency.graphic_1.subtitle')"
              ></div>
              <div class="head-block__graphic-list">
                <div
                  class="head-block__graphic-item blue-dot"
                  v-html="$t('efficiency.graphic_1.item_1')"
                ></div>
                <div
                  class="head-block__graphic-item gray-dot"
                  v-html="$t('efficiency.graphic_1.item_2')"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-x-lg-6 col-lg-6 col-md-6 col-xs-12">
            <div class="head-block__graphic">
              <div
                class="head-block__graphic-title"
                v-html="$t('efficiency.graphic_2.title')"
              ></div>
              <div class="head-block__graphic-image">
                <img
                  v-if="$i18n.locale === 'ua'"
                  src="~@/assets/img/efficiency/graphic-2.png"
                  alt=""
                />
                <img
                  v-if="$i18n.locale === 'ru'"
                  src="~@/assets/img/efficiency/graphic-2-ru.png"
                  alt=""
                />
              </div>
              <div
                class="head-block__graphic-subtitle"
                v-html="$t('efficiency.graphic_2.subtitle')"
              ></div>
              <div class="head-block__graphic-list">
                <div
                  class="head-block__graphic-item gray-dot"
                  v-html="$t('efficiency.graphic_2.item_1')"
                ></div>
                <div
                  class="head-block__graphic-item blue-dot"
                  v-html="$t('efficiency.graphic_2.item_2')"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="head-block__footer">
          <div class="row">
            <div class="col-x-lg-6 col-lg-6 col-md-6 col-xs-12">
              <router-link
                @click.native="effectivenessMainBtn()"
                :to="$t('efficiency.button.link')"
                class="head-block__footer-btn"
                >{{ $t("efficiency.button.title") }}</router-link
              >
            </div>
            <div class="col-x-lg-6 col-lg-6 col-md-6 col-xs-12">
              <div
                class="head-block__footer-info"
                v-html="$t('efficiency.info')"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->

    <!-- Begin bibliography -->
    <section class="bibliography">
      <div class="container">
        <div class="bibliography__info">
          <p v-html="$t('bibliography.info_1')"></p>
        </div>
        <div class="bibliography__list">
          <h3
            class="bibliography__list-title"
            v-html="$t('bibliography.bibliographyTitle')"
          ></h3>
          <div
            class="bibliography__list-item"
            v-for="(item, key) in $t('efficiency.bibliography.list')"
            :key="key"
          >
            <div class="bibliography__list-number">{{ key + 1 }}.</div>
            <div class="bibliography__list-text" v-html="item"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
  </div>
</template>

<script>
export default {
  name: "EfficiencyView",
  metaInfo() {
    if (this.$i18n.locale === "ua") {
      return {
        title: "Швидкість ⏱ та тривалість ⌛ в одному флаконі",
        meta: [
          {
            name: "description",
            content:
              "Полегшення нежитю вже через 25 секунд ⏱ Тривалість дії до 12 годин ⌛ Скорочує тривалість риніту на 2 дні 📅"
          },
          {
            property: "og:description",
            content: "Швидкість ⏱ та тривалість ⌛ в одному флаконі"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (this.$i18n.locale === "ru") {
      return {
        title: "Быстрота ⏱ и длительность ⏳ действия Називин® Сенситив",
        meta: [
          {
            name: "description",
            content:
              "Облегчение насморка уже через 25 секунд ⏱ Продолжительность действия до 12:00 ⌛ сокращает продолжительность ринита на 2 дня 📅"
          },
          {
            property: "og:description",
            content: "Быстрота ⏱ и длительность ⏳ действия Називин® Сенситив"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
  },
  methods: {
    effectivenessMainBtn() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", {
        event_category: "effectiveness_main_btn"
      });
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/views/_efficiency";
</style>
